import React, { useEffect, useState } from 'react';
import Sidebar from '../../components/sidebar/sidebar';
import Header from '../../components/header';
import Card from '../../components/Card';
import { useNavigate, useParams } from 'react-router-dom';
import UploadScriptForm from './UploadScriptForm';
import axios from 'axios';
import Project from '../../common/Utils/project';
import { useAuth } from 'oidc-react';
import { LoaderCircle } from 'lucide-react';
import { useTenantSelection } from '../../providers/TenantSelectionProvider';

const CreateNewScript = () => {
  const navigate = useNavigate();
  const { id } = useParams(); // scriptId from URL for edit
  const auth = useAuth();
  const [loading, setLoading] = useState(false);
  const [scriptData, setScriptData] = useState<any>(null);
  const { selectedTenantId } = useTenantSelection();
  useEffect(() => {
    if (id) {
      // Edit Mode: Fetch script details
      const fetchScriptData = async () => {
        try {
          setLoading(true);
          const token = auth?.userData?.access_token;
          const tenantId = selectedTenantId;
          const response = await axios.get(`${Project.api}tenantservice/TenantScript/${tenantId}/tenant-script-by-id/${id}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });

          if (response.data?.isSuccess) {
            setScriptData(response.data.data[0]); // assuming API returns { data: {...} }
          }
        } catch (error) {
          console.error('Error fetching script data:', error);
        } finally {
          setLoading(false);
        }
      };

      fetchScriptData();
    }
  }, [id, auth]);

  return (
    <div className="flex">
      <Sidebar />
      <div className="bg-[var(--Background-Color,rgb(7,7,7))] flex-1">
        <Header title={id ? 'Edit Script' : 'Add New Script'} dropdown={2} showBackButton={true} />

        <Card className="flex-1">
          {loading ? (
            <div className="flex justify-center items-center h-40">
              <LoaderCircle className="animate-spin w-8 h-8 text-gray-400" />
            </div>
          ) : (
            <UploadScriptForm scriptData={scriptData} isEdit={!!id} />
          )}
        </Card>
      </div>
    </div>
  );
};

export default CreateNewScript;
